import React from 'react';
import { Star, ExternalLink } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { reviews } from '../mockData';
import { trackEvent } from '../lib/analytics';

const GOOGLE_REVIEWS_URL = 'https://share.google/GNY1yTFbbazLSE6Rl';

export const Reviews = () => {
  return (
    <section id="reviews" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-[#1E3A5F] mb-4">What Our Clients Say</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Don't just take our word for it. Here's what our satisfied customers have to say about their experience.
          </p>
        </div>

        {/* Reviews Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reviews.map((review) =>
          <Card key={review.id} className="border-2 border-gray-100 hover:shadow-xl transition-shadow duration-300">
              <CardContent className="pt-6">
                {/* Rating Stars */}
                <div className="flex items-center mb-4">
                  {[...Array(review.rating)].map((_, i) =>
                <Star key={i} className="w-5 h-5 text-yellow-400 fill-current" />
                )}
                </div>

                {/* Review Text */}
                <p className="text-gray-700 mb-4 leading-relaxed">"{review.comment}"</p>

                {/* Reviewer Info */}
                <div className="border-t border-gray-100 pt-4">
                  <p className="font-semibold text-[#1E3A5F]">{review.name}</p>
                  <p className="text-xs text-gray-400 mt-1">{review.date}</p>
                </div>
              </CardContent>
            </Card>
          )}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">Be one of our satisfied customers across Sydney</p>
          <div className="flex items-center justify-center space-x-1">
            {[...Array(5)].map((_, i) =>
            <Star key={i} className="w-6 h-6 text-yellow-400 fill-current" />
            )}
            <span className="ml-2 text-lg font-bold text-[#1E3A5F]">5.0 Average Rating</span>
          </div>

          <a
            href={GOOGLE_REVIEWS_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackEvent('click_google_reviews', { location: 'reviews_section' })}
            data-testid="google-reviews-link"
            className="inline-flex items-center gap-2 mt-6 px-6 py-3 rounded-full border-2 border-[#1E3A5F] text-[#1E3A5F] font-semibold hover:bg-[#1E3A5F] hover:text-white transition-all duration-300"
          >
            Read all our reviews on Google
            <ExternalLink className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>);

};